import Actions         from "../../../../model/constant/actions"
import ReducerUtils    from "../../../../utils/ReducerUtils"

const Failed = ReducerUtils.createReducer<boolean>(false,{
  [Actions.FAILED_RETRIEVING_ADCOPY_ACTIVE_STRATEGIES] : (_state,action) => action.status
})

export default Failed
